import * as api from '@utils/api'
import createAction from '../create-action'
import { ApiDispatch, UserFormType, UserType } from '@types'
import {
  CREATE_USER,
  CREATE_USER_FAILURE,
  DELETE_USER,
  SAVE_USER,
  SAVE_USER_FAILURE,
  SET_USER,
  SET_USERS,
} from '@store/action-list'
import { apiAction } from '@store/actions/api'

export const setUser = createAction<UserType>(SET_USER)
export const setUsers = createAction<UserType[]>(SET_USERS)
export const deleteUser = createAction<UserType>(DELETE_USER)
export const createUserSuccess = createAction<UserType>(CREATE_USER)
const createUserFailure = createAction(CREATE_USER_FAILURE)
export const saveUserSuccess = createAction<UserType>(SAVE_USER)
const saveUserFailure = createAction(SAVE_USER_FAILURE)

export const getUser = (id: string): ApiDispatch => {
  return apiAction({
    url: `/p4/users/${id}`,
    method: 'GET',
    actionCallbacks: {
      success: setUser,
    },
  })
}

export const getUsers = (): ApiDispatch =>
  apiAction({
    url: '/p4/users',
    method: 'GET',
    actionCallbacks: {
      success: setUsers,
    },
  })

export const saveUser = (userData: UserFormType): ApiDispatch =>
  apiAction({
    url: `/p4/users/${userData.id}`,
    method: 'PATCH',
    data: userData,
    actionCallbacks: {
      success: saveUserSuccess,
      failure: saveUserFailure,
    },
  })

export const uploadPhotoUser = (id: number, imageData: string): ApiDispatch =>
  apiAction({
    url: `/p4/users/${id}/photo`,
    method: 'POST',
    data: { image_data: imageData },
    actionCallbacks: {
      success: saveUserSuccess,
      failure: saveUserFailure,
    },
  })

export const removePhotoUser = (id: number): ApiDispatch =>
  apiAction({
    url: `/p4/users/${id}/photo`,
    method: 'DELETE',
    actionCallbacks: {
      success: saveUserSuccess,
      failure: saveUserFailure,
    },
  })

export const createUser = (userData: UserFormType): ApiDispatch =>
  apiAction({
    url: '/p4/users',
    method: 'POST',
    data: userData,
    actionCallbacks: {
      success: createUserSuccess,
      failure: createUserFailure,
    },
  })

export const demoteUser = (id: number): ApiDispatch =>
  apiAction({
    url: `/p4/users/${id}`,
    method: 'PATCH',
    data: {
      id,
      role_ids: [],
      permission_ids: [],
    },
    actionCallbacks: {
      success: deleteUser,
    },
  })

export const getFilteredUsers = (filters) => async (dispatch) => {
  const {
    data: { users },
  } = await api.GET('/p4/users', filters)

  return dispatch({
    type: SET_USERS,
    payload: users,
  })
}

export const resetPassword = async (email) => {
  const { data } = await api.POST('/p4/passwordReset', { email })

  return data
}

export const ccpaDelete = async (id, email) => {
  const { data: response } = await api.DELETE(`/p4/users/${id}`, {
    email: email,
  })
  return response
}

export const ccpaExport = async (id, email) => {
  const { data: response } = await api.POST(`/p4/users/${id}/export`, {
    email: email,
  })
  return response
}

export const banEmail = async (email) => {
  const { data: response } = await api.POST(`/p4/bannedEmails`, {
    email: email,
  })
  return response
}

export const getRewards = async (id) => {
  const { data: response } = await api.GET(`/p4/users/${id}/rewards`)
  return response
}
